// Test Cross-Tab Logout Functionality
// Run this in browser console to verify cross-tab logout

window.testCrossTabLogout = () => {
  console.log('🧪 Testing Cross-Tab Logout...')

  // Check if inactivity manager exists
  if (!window.inactivityManager) {
    console.error('❌ Inactivity manager not found')
    return
  }

  console.log('📊 Current Status:')
  console.log('- Tabs should all show login page after logout')
  console.log('- Message should appear on login: "You have been logged out due to inactivity."')

  // Force quick test
  window.inactivityManager.setInactivityDuration(0.1) // 6 seconds
  window.inactivityManager.warningDuration = 3000 // 3 seconds warning

  console.log('⚡ Set to 6-second total timeout (3-second warning)')
  console.log('✅ Warning should appear after 3 seconds in ALL tabs')
  console.log('🚨 ALL tabs will logout after 6 seconds total')

  window.inactivityManager.enable()
  window.inactivityManager.startInactivityTimer()

  console.log('🕐 Timer started. Don\'t interact for 3 seconds to see warning in all tabs!')
}

// Test if localStorage communication works
window.testStorageComm = () => {
  console.log('📡 Testing localStorage cross-tab communication...')

  // Simulate logout signal
  localStorage.setItem('udara360_logout_all_tabs', JSON.stringify({
    tabId: 'test-tab',
    timestamp: Date.now(),
  }))

  console.log('✅ Logout signal sent. All tabs should redirect to login now!')
}

console.log('🔧 Cross-Tab Logout Test Functions Available:')
console.log('- window.testCrossTabLogout() - Test full cross-tab logout flow')
console.log('- window.testStorageComm() - Test localStorage communication')
